module.exports = __webpack_public_path__ + "static/assets/80d8c538b19491122d263a63ccc64a86.gif";